import { useInterval } from "./useInterval";
import {
  CANVAS_SIZE,
  APPLE_START,
  DIRECTIONS,
  SCALE,
  SNAKE_START,
  SPEED,
} from "./consts";
import "./SnakeGame.scss";
import { useEffect, useRef, useState } from "react";

const SnakeGame=({onChange})=> {
  const canvasRef = useRef();
  const [snake, setSnake] = useState(SNAKE_START);
  const [apple, setApple] = useState(APPLE_START);
  const [dir, setDir] = useState([0, -1]);
  const [speed, setSpeed] = useState(null);
  const [gameOver, setGameOver] = useState(false);
  const [gameStarted, setGameStarted] = useState(false);

  useInterval(() => gameLoop(), speed);

  const endGame = () => {
    setSpeed(null);
    setGameOver(true);
  };

  const moveSnake = ({ keyCode }) =>
    keyCode >= 37 && keyCode <= 40 && setDir(DIRECTIONS[keyCode]);

  const createApple = () =>
    apple.map((_a, i) => Math.floor(Math.random() * (CANVAS_SIZE[i] / SCALE)));

  const checkCollision = (piece, snk = snake) => {
    if (
      piece[0] * SCALE >= CANVAS_SIZE[0] ||
      piece[0] < 0 ||
      piece[1] * SCALE >= CANVAS_SIZE[1] ||
      piece[1] < 0
    )
      return true;

    for (const segment of snk) {
      if (piece[0] === segment[0] && piece[1] === segment[1]) return true;
    }
    return false;
  };

  const checkAppleCollision = (newSnake) => {
    if (newSnake[0][0] === apple[0] && newSnake[0][1] === apple[1]) {
      let newApple = createApple();
      while (checkCollision(newApple, newSnake)) {
        newApple = createApple();
      }
      setApple(newApple);
      return true;
    }
    return false;
  };

  const gameLoop = () => {
    const snakeCopy = JSON.parse(JSON.stringify(snake));
    const newSnakeHead = [snakeCopy[0][0] + dir[0], snakeCopy[0][1] + dir[1]];
    snakeCopy.unshift(newSnakeHead);
    if (checkCollision(newSnakeHead)) endGame();
    if (!checkAppleCollision(snakeCopy)) snakeCopy.pop();
    setSnake(snakeCopy);
  };
  const startGame = () => {
    setSnake(SNAKE_START);
    setApple(APPLE_START);
    setDir([0, -1]);
    setSpeed(SPEED);
    setGameOver(false);
    setGameStarted(true);
  };

  useEffect(() => {
    const context = canvasRef.current.getContext("2d");
    context.setTransform(SCALE, 0, 0, SCALE, 0, 0);
    context.clearRect(0, 0, window.innerWidth, window.innerHeight);
    context.fillStyle = "#43D9AD";
    snake.forEach(([x, y]) => context.fillRect(x, y, 1, 1));
    // food
    context.fillStyle = "#43D9AD";
    if (snake.length < 14) {
      context.fillRect(apple[0], apple[1], 1, 1);
    }
  }, [snake, apple, gameOver]);

  useEffect(() => {
    onChange(snake.length);
    if (snake.length >= 14) {
      setSpeed(null);
      setGameOver(true);
    }
  }, [snake, onChange]);
  return (
    <div
      role="button"
      tabIndex="0"
      className="play-board"
      onKeyDown={(e) => moveSnake(e)}
    >
      <canvas
        ref={canvasRef}
        width={`${CANVAS_SIZE[0]}px`}
        height={`${CANVAS_SIZE[1]}px`}
      />
      {gameOver && (
        <div className="game-over-band">
          {snake.length >= 14 ? "WELL DONE!" : "GAME OVER!"}
        </div>
      )}
      {!gameStarted && (
        <div className="start-game-btn">
          <div onClick={startGame}>start-game</div>
        </div>
      )}
      {gameOver && (
        <div className="start-again-btn">
          <div
            style={snake.length >= 14 ? { color: "#fff" } : {}}
            onClick={startGame}
          >
            {snake.length >= 14 ? "play-again" : "start-again"}
          </div>
        </div>
      )}
    </div>
  );
}
export default SnakeGame;
